import { InfoIcon } from '@chakra-ui/icons';
import { motion } from 'framer-motion';
import {
  Container,
  Flex,
  Text,
  Image,
  VStack,
  useColorModeValue,
  Highlight,
  Link
} from '@chakra-ui/react';
import React from 'react';
// import ButtonDesign1 from './Elements/ButtonDesign1';
import { techSvgArray } from './Elements/TechIcons';
import AnimatedPage from './Other/AnimatedPage';
import Profile from './Profile';
import aboutMeDescription from './Data/AboutData';
import { Link as RouterLink } from 'react-router-dom';
import resume from '../Images/Lior-Reuven-Resume.pdf'

const About = () => {
  const underlineColor = useColorModeValue(
    'rgb(64,64,64,0.3)',
    'rgb(255,255,255,0.6)'
  );
  let delay = 0;

 

  return (
    <>
      <AnimatedPage>
        <Flex
          minH={'66vh'}
          borderBottom={`1px solid ${underlineColor}`}
          alignItems={'flex-start'}
          justifyContent={['space-between', 'space-between']}
          direction={'column'}
          mt={['2rem', '2rem', null, null, null]}
        >
          <Flex
            w={'100%'}
            borderBottom={`1px solid ${underlineColor}`}
            justifyContent={'center'}
            mx={'auto'}
            mb={'1.5rem'}
          >
            <InfoIcon
              mb={'20px'}
              boxSize={['40px', '40px', '50px', '50px']}
              color={'blue.500'}
            ></InfoIcon>
          </Flex>
          <Flex
            w={'100%'}
            alignItems={['center', 'center', 'center', 'flex-start']}
            justifyContent={'space-between'}
            direction={[
              'column-reverse',
              'column-reverse',
              'column-reverse',
              'row',
              'row',
              'row',
            ]}
          >
            <Container
              p={'0'}
              m={'0'}
              mt={['2rem', '2rem', '2rem', '0', '0', '0']}
              mr={['0', '0', '0', '3rem', '3rem', '3rem']}
            >
              <VStack spacing={'30px'}>
                <Text
                  whiteSpace={'pre-wrap'}
                  fontSize={['xs', 'sm', 'lg', 'lg']}
                >
                  {aboutMeDescription}
                  <Link as={RouterLink} to={resume} target="_blank" download>
                  <Highlight
                    query="Resume"
                    styles={{ px: '1', py: '1', bg: '#47d6fe', rounded:'5px' }}
                  >
                    Resume
                  </Highlight>
                  </Link>
                  <br></br>
                  <br></br>
                  Thank you!
                </Text>
              </VStack>
            </Container>
            <Profile />
          </Flex>
          {/* <ButtonDesign1
            size={['sm', 'md', null, null]}
            mt={'2rem'}
            alignSelf={'center'}
          ></ButtonDesign1> */}
          <Flex
            wrap={'wrap'}
            mx={'auto'}
            mt={'2rem'}
            w={['90%', '90%', '90%', '80%']}
            justifyContent={'space-evenly'}
          >
            {techSvgArray.map((techIcon, index) => {
              return (
                <Flex
                  as={motion.div}
                  initial={{ opacity: 0, scale: 0, x: -100 }}
                  animate={{ opacity: 1, scale: 1, x: 0 }}
                  transition={` 1s ${(delay += 0.4)}s`}
                  mb={'2rem'}
                  w={{ base: '25%', md: '20%' }}
                  key={index}
                  alignItems={'center'}
                  direction={'column'}
                >
                  <Image
                    mb={'8px'}
                    src={techIcon.src}
                    w={['60%', '60%', '60%', '100%', '100%']}
                    maxH={'70px'}
                  ></Image>
                  <Text
                    fontWeight={'semibold'}
                    letterSpacing={'2px'}
                    fontFamily={'montseratt, sans-serif'}
                    fontSize={['7px', '8px', '8px', '8px']}
                  >
                    {techIcon.name}
                  </Text>
                </Flex>
              );
            })}
          </Flex>
        </Flex>
      </AnimatedPage>
    </>
  );
};

export default About;
